$(document).ready(function(){
  eventModal();
  $('.synergy_anchor_thumb').on('click',function(e){
    var sy_data = $(this).attr('data-media');
    $('.synergy_media').hide();
    $( ".synergy_media" ).each(function( index ) {
      var sy_data_2 = $(this).attr('data-media');
      if(sy_data_2 == sy_data){
      	$(this).show();
      }
    });

    $(".product-images .synergy_image_thumb").removeClass("active-thumb");
    $(this).closest(".synergy_image_thumb").addClass("active-thumb");

  });
  setTimeout(function(){
if($(".product-form div.selector-wrapper").length == 1){
  $('.product-form div.selector-wrapper').prepend('<label for="option-0">Color</label>');
  }  }, 3000);



  $('.selector-wrapper').click(function(){

    var swatch_name = $(this).find('label').html();
	console.log(swatch_name);
    if($(".swatch." + swatch_name +"_swatches").hasClass('open')){
     $(".swatch").removeClass('open');
    }else{
      $(".swatch").removeClass('open');
    $(".swatch." + swatch_name +"_swatches").addClass('open');
    }
  });
});

function eventModal () {
  const modalBtns = document.querySelectorAll('[js-item-modal]');
  const modalContents = document.querySelectorAll('[js-item-modal-content]');
  const modalCloseBtns = document.querySelectorAll('[js-bg-modal]');
  
  modalBtns.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const id = button.getAttribute('data-id');
      modalContents.forEach(content => {
        if (content.getAttribute('data-id') == id) {
          content.classList.remove('hidden');
        } else {
          content.classList.add('hidden');
        }
      });
    });
  });

  modalCloseBtns.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const id = button.getAttribute('data-id');

      modalContents.forEach(content => {
        if (content.getAttribute('data-id') == id) {
          content.classList.add('hidden');
        }
      });
    });
  });
}

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
function updateQueryString(key, value, url) {
    if (!url) url = window.location.href;
    let updated = ''
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
        hash;
    if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null) {
            updated = url.replace(re, '$1' + key + "=" + value + '$2$3');
        }
        else {
            hash = url.split('#');
            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            updated = url;
        }
    }
    else {
        if (typeof value !== 'undefined' && value !== null) {
            var separator = url.indexOf('?') !== -1 ? '&' : '?';
            hash = url.split('#');
            url = hash[0] + separator + key + '=' + value;
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            updated = url;
        }
        else {
            updated = url;
        }
    }
    window.history.replaceState({ path: updated }, '', updated);
}
function trigger(e){
  let shape = '';
  let color = '';
  let metal = '';
  console.log("name", e.target.querySelector('input').name)
  if (e.target.querySelector('input').name === 'option-0' && e.target.querySelector('input').classList.contains('color-swatch-input')) {
    color = e.target.querySelector('input').value;
    shape = document.querySelector('.shape-swatch-input:checked').value;
  } else if (e.target.querySelector('input').name === 'option-1' && e.target.querySelector('input').classList.contains('shape-swatch-input')){
    color = document.querySelector('.color-swatch-input:checked').value;
    shape = e.target.querySelector('input').value;
  } else if (e.target.querySelector('input').name === 'option-0' && e.target.querySelector('input').classList.contains('shape-swatch-input')) {
    color = document.querySelector('.color-swatch-input:checked').value;
    shape = e.target.querySelector('input').value;
    metal = document.querySelector('.metal-swatch-input:checked').value;
  } else if (e.target.querySelector('input').name === 'option-1' && e.target.querySelector('input').classList.contains('metal-swatch-input')) {
    color = document.querySelector('.color-swatch-input:checked').value;
    shape = document.querySelector('.shape-swatch-input:checked').value;
    metal = e.target.querySelector('input').value;
  } else if (e.target.querySelector('input').name === 'option-2' && e.target.querySelector('input').classList.contains('color-swatch-input')) {
    color = e.target.querySelector('input').value;
    shape = document.querySelector('.shape-swatch-input:checked').value;
    metal = document.querySelector('.metal-swatch-input:checked').value;
  } else if (e.target.querySelector('input').name === 'option-0' && e.target.querySelector('input').classList.contains('shape-swatch-input')) {
    shape = e.target.querySelector('input').value;
  }
  const variants = document.querySelectorAll('#product-select option');
  let variantId = document.querySelectorAll('#product-select option')[0].getAttribute('data-variant-id');
  variants.forEach((variant) => {
    if (metal == '') {
      if ( variant.getAttribute('data-option0') === color && variant.getAttribute('data-option1') === shape ){
        variantId = variant.getAttribute('data-variant-id')
      }
      if (variant.getAttribute('data-option0') === shape) {
        variantId = variant.getAttribute('data-variant-id')
      }
    } else {
      if ( variant.getAttribute('data-option0') === shape && variant.getAttribute('data-option1') === metal && variant.getAttribute('data-option2') === color ){
        variantId = variant.getAttribute('data-variant-id')
      }
    }
  })
  updateQueryString('variant', variantId);
}
const swatchShapes = document.querySelectorAll('.variant-link');
swatchShapes.forEach((swatchShape) => {
  swatchShape.addEventListener('click', trigger, false);
});

var variantId = getParameterByName('variant');
if (variantId) {
  const variants = document.querySelectorAll('#product-select option');
  variants.forEach((variant) => {
    if ( variant.getAttribute('data-variant-id') === variantId ){
        const color = variant.getAttribute('data-option1');
        const shape = variant.getAttribute('data-option0');
        const colorSwatches = document.querySelectorAll('.metal-swatch-input');
        if (colorSwatches) {
          colorSwatches.forEach((colorSwatch) => {
            if (colorSwatch.value === color){
              colorSwatch.setAttribute('checked', 'checked')
            }
          })
        }
        const shapeSwatches = document.querySelectorAll('.shape-swatch-input');
        if (shapeSwatches){
          shapeSwatches.forEach((shapeSwatch) => {
            if (shapeSwatch.value === shape){
                shapeSwatch.setAttribute('checked', 'checked')
            }
          })
        }
      }
  })
}

function changeCheckedMetal(e) {
  console.log(e.target)
  e.target.closest('.metal-swatches-wrapper').querySelector('.variant-link.selected').classList.remove('selected');
  e.target.classList.add('selected');
  e.target.closest('.metal-swatches-wrapper').querySelector('input[checked="checked"]').removeAttribute('checked');
  e.target.querySelector('input').setAttribute('checked', 'checked');
}
let metalInput = document.querySelectorAll('.metal-swatch');
for (let i = 0; i < metalInput.length; i++) {
  metalInput[i].addEventListener('click', changeCheckedMetal);
}

function changeCheckedMaterial(e) {
  console.log(e.target)
  e.target.closest('.material-swatches-wrapper').querySelector('.variant-link.selected').classList.remove('selected');
  e.target.classList.add('selected');
  e.target.closest('.material-swatches-wrapper').querySelector('input[checked="checked"]').removeAttribute('checked');
  e.target.querySelector('input').setAttribute('checked', 'checked');
}
let materialInput = document.querySelectorAll('.material-swatch');
for (let i = 0; i < materialInput.length; i++) {
  materialInput[i].addEventListener('click', changeCheckedMaterial);
}

function changeCheckedColor(e) {
  console.log(e.target)
  e.target.closest('.color-swatches-wrapper').querySelector('.variant-link.selected').classList.remove('selected');
  e.target.classList.add('selected');
  e.target.closest('.color-swatches-wrapper').querySelector('input[checked="checked"]').removeAttribute('checked');
  e.target.querySelector('input').setAttribute('checked', 'checked');
}
let colorInput = document.querySelectorAll('.color-swatch');
for (let i = 0; i < colorInput.length; i++) {
    colorInput[i].addEventListener('click', changeCheckedColor);
}

function changeCheckedShape(e) {
  console.log(e.target)
  e.target.closest('.shape-swatches-wrapper').querySelector('.variant-link.selected').classList.remove('selected');
  e.target.classList.add('selected');
  e.target.closest(".shape-swatches-wrapper").querySelector('input[checked="checked"]').removeAttribute('checked');
  e.target.querySelector('input').setAttribute('checked', 'checked');
}
let shapeInput = document.querySelectorAll('.shape-swatch');
for (let i = 0; i < shapeInput.length; i++) {
    shapeInput[i].addEventListener('click', changeCheckedShape);
}

const $variantsSelector = $('[data-all-variants]');
const $productOption = $('[data-product-option]');
const $qtySelector = $('[data-qty]');

const updateProduct = function () {
  const $variantSelected = $('option:selected', $variantsSelector);
  updatePrice($variantSelected);
  updateOptions($variantSelected);
  updateButton($variantSelected);
  updateLowStock($variantSelected);
  updateTopLabel($variantSelected);
  updateImage($variantSelected);
  // updateRecharge($variantSelected);
}

const formatMoney = function(price) {
  // return '$' + price/100 + '.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD' // Replace 'USD' with your shop's currency if different
  }).format(price / 100);
}

const updateImage = function($variantSelected) {

  console.log($variantSelected.val());
  const slideIndex = $('.product-slider [data-variant=' + $variantSelected.val() + ']').data('index');
  $('.product-slider [data-variant]').each(function(index, slide){
    if($(slide).data('variant-ids')) {
      if($(slide).data('variant-ids').includes($variantSelected.val())) {
        $('.product-slider').slick('slickGoTo', $(slide).data('index'));
      }
    }
  })

}

const updatePrice = function($variantSelected) {
  const $price = $('[data-price]');
  const $priceCompare = $('[data-price-compare]');
  const price = $variantSelected.data('variant-price');
  const comparePrice = $variantSelected.data('variant-compare-price');
  $price.text(formatMoney(price));
  comparePrice > 0 ? $priceCompare.text(formatMoney(comparePrice)).show() : $priceCompare.hide();

   if(window.BOLD && BOLD.pre){
        BOLD.pre.events.emit("variant_changed", {variant: $variantSelected});
      }
}

const updateButton = function($variantSelected) {
  const $addToCart = $('[data-add-to-cart]');
  if ($variantSelected.data('subscription-id') != '') {
    let text = window.theme.strings.recharge;
    if ($variantSelected.data('product-handle').indexOf('annual') != -1) {
      let price = formatMoney($variantSelected.data('variant-price'));
      text += ' - '+price;
    }
    $addToCart.attr('disabled', false).text(text);
  } else if ($variantSelected.data('available') == true) {
    if ($variantSelected.data('inventory-policy') == 'continue' && $variantSelected.data('inventory-quantity') <= 0) {
      $addToCart.attr('disabled', false).text(window.theme.strings.preOrder);
    } else {
      if($addToCart.data('pre-order') == true) {
        $addToCart.attr('disabled', false).text(window.theme.strings.preOrder);
      } else {
        $addToCart.attr('disabled', false).text(window.theme.strings.addToCart);
      }
    }
  } else {
    $addToCart.attr('disabled', true).text(window.theme.strings.soldOut);
  }
}

const updateTopLabel = function($variantSelected) {
  const $topLabel = $('.product-info__top-label').find('span');
  if ($variantSelected.data('product-handle').indexOf('annual') != -1 && $variantSelected.data('subscription-id') != '' && $topLabel.length) {
    let text = window.theme.strings.recharge;
    let price = formatMoney($variantSelected.data('variant-price'));
    text += ' - ' + price;
    text = $(`<b>${text}</b>`);
    $topLabel.html(text);
  }
}

const updateLowStock = function($variantSelected) {
  const $lowStock = $('[data-low-stock]');
  if ($variantSelected.data('available')) {
    $lowStock.removeClass('hide');
  } else {
    $lowStock.addClass('hide');
  }
}

const updateOptions = function($variantSelected) {
  // Update option 1
  $('[data-product-option=1]').each(function (index, option1) {
    let disabled = true;
    const optionVal = $(option1).val();
    $variantsSelector.find('option').each(function (index, selectOption) {
      if ($(selectOption).data('option1') == optionVal && $(selectOption).data('available') == true) {
        disabled = false;
      }
    });
    if (disabled) {
      // $(option1).attr('disabled', true);
      $(option1).addClass('is-disabled');
    }
  });

  // Update options 2 and 3
  const option1 = $variantSelected.data('option1');
  $variantsSelector.find('option').each(function (index, selectOption) {
    if ($(selectOption).data('option1') == option1) {
      const option2 = $(selectOption).data('option2');
      const $option2 = $(`[data-product-option=2][value='${option2}']`);
      const option3 = $(selectOption).data('option3');
      const $option3 = $(`[data-product-option=3][value='${option3}']`);
      if ($(selectOption).data('available') == false) {
        // $option2.attr('disabled', true);
        // $option3.attr('disabled', true);
        $(option2).addClass('is-disabled');
        $(option3).addClass('is-disabled');
      } else {
        $option2.attr('disabled', false);
        $option3.attr('disabled', false);
      }
    }
  });
}


  $variantsSelector.on('change', function() {
    updateProduct();
  });

  $qtySelector.on('change', function() {
    updateProduct();
  });

  // Options changing
  $productOption.on('click', function () {
    const option1 = $('[data-product-option=1]:checked').length ? $('[data-product-option=1]:checked').val() : '_BLANK_';
    const option2 = $('[data-product-option=2]:checked').length ? $('[data-product-option=2]:checked').val() : '_BLANK_';
    const option3 = $('[data-product-option=3]:checked').length ? $('[data-product-option=3]:checked').val() : '_BLANK_';
    console.log(option1, option2, option3);
    const value = $variantsSelector.find(`[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
    console.log(value);
    if(!value) {
      const option2all = $('[data-product-option=2]');
      console.log(option2all);
      for(var i = 0; i < option2all.length; i++) {
        var optionValue = $(option2all[i]).val();
        const val = $variantsSelector.find(`[data-option1='${option1}'][data-option2='${optionValue}'][data-option3='${option3}']`).val();
        if(val) {
          $(option2all[i]).prop('checked', true);
          break;
        }
      }

    } else {
      $variantsSelector.val(value).trigger('change');
      console.log('variantselector value', $variantsSelector.val());
      $('[data-variant-id]').val($variantsSelector.val())
    }
  });

  if (window.productTemplateLoaded) {
    updateProduct();
  }


  var swiper = new Swiper(".home-slider-wrapper", {
    slidesPerView: 1,
    grabCursor: true,
    spaceBetween: 30,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });